<template>
  <pbc-modal title='Edit Variable' @close='$emit("close")' @done="done">
    <div>
      <div class="flex m-2">
        <div class="flex-none w-48">Name</div>
        <input v-model='value.name' class="pbc-standard-input" placeholder='Enter name'/>
      </div>
      <div class="flex m-2">
        <div class="flex-none w-48">Initial Value</div>
        <input v-model='value.initial' class="pbc-standard-input" placeholder='Enter initial value'/>
      </div>
    </div>
  </pbc-modal>
</template>
<script>
export default {
  props:{
    value:{
      type:Object,
      required:true
    },
    source:{
      type:Array,
      required:true
    }
  },
  data() {
    return {
    }
  },
  methods:{
    done() {
      this.$emit("close");
    }
  }
}
</script>
